export default function loadImage(url) {
  return new Promise((resolve, reject) => {
    var image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function() { resolve(image) };
    image.onerror = function() { reject("Failed to load image") };
    image.src = url;
  });
}
